import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { RootState } from "../../services/redux/store";
import { useSelector, useDispatch } from "react-redux";
import {
  userBusinessSelector,
  userLoanCatSelector,
  userPermissionSelector,
  authSelector,
} from "../../services/redux/slices/authSlice";
import { setSelectedLoanNumber } from "../../services/redux/slices/dashboardDataSlice";
import postsServices from "../../services/api/service/postsService";
import { resetDisbursementButtonValue } from "../../services/redux/slices/disbursementButtonSlice";
import AccountSummary from "../../pages/dashboard/flexiTermLoan/AccountSummary";
import Withdraw from "../../pages/dashboard/flexiTermLoan/Withdraw";
import MyPayments from "../../pages/dashboard/flexiTermLoan/Payment";
import Statement from "../../pages/dashboard/flexiTermLoan/Statement";
import { setSelectedIndex } from "../../services/redux/slices/tabsSlice";
import PermissionView from "../../pages/dashboard/flexiTermLoan/PermissionView";
import AccountSummaryTerm from "../../pages/dashboard/termLoan/AccountSummaryTerm";
import DisbursementContainer from "../../pages/dashboard/termLoan/DisbursementContainer";
import { setDocumentDiscardModal } from "../../services/redux/slices/documentFormSlice";
import CustomTabs from "../ui/Tabs";
import Breadcrumbs from "../ui/Breadcrumbs";
import { encrypt, decrypt } from "../../utils/crypto";
import {
  setDashboardData,
  setMoratStatus,
} from "../../services/redux/slices/dashboardDataSlice";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import { useLocation, useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
interface DynamicTab {
  label: string;
  content: React.ReactNode;
}
interface DashboardData {
  lanNumber: string;
  statusOfLoan: string;
  loanAmount: number;
  outstandingPrincipal: number;
  emiAmount: number;
  nextEmiDate: string;
  overdueAmount: number;
  description: string;
  firstDisbDate: string;
  maturityDate: string;
  loanTypeId: number;
  isExistDisbursementAllowdLoan: boolean;
}
// Define the tab configurations
const tabsComponentTermLoan: DynamicTab[] = [
  // { label: "Account Summary", content: <AccountSummaryTerm /> },
  { label: "Loan Summary", content: <AccountSummaryTerm /> },
];
const tabsComponentRequestForDisbursementTranchRequest: DynamicTab[] = [
  { label: "Disbursement", content: <DisbursementContainer /> },
];
const tabsComponentFlexiTermLoan: DynamicTab[] = [
  { label: "Account Summary", content: <AccountSummary /> },
  { label: "Withdrawal", content: <Withdraw /> },
  { label: "Payment", content: <MyPayments /> },
  { label: "Statements", content: <Statement /> },
];
//  not in used currently
const tabsComponentRequestForDisbursement: DynamicTab[] = [
  { label: "Account Summary", content: <AccountSummaryTerm /> },
  { label: "Withdrawal Funds", content: <Withdraw /> },
  { label: "Make Payment", content: <MyPayments /> },
  { label: "Documents", content: <Statement /> },
  { label: "Mandate", content: <Statement /> },
  { label: "Service Request", content: <Statement /> },
];
const CustomTabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && (
        <Box>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const FlexiTermLoan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedIndex = useSelector(
    (state: RootState) => state?.tabs?.selectedIndex
  );
  const [error, setError] = useState<string | null>(null); // Define the error state
  const selectDisbDetailIndex: number = useSelector(
    (state: RootState) => state?.tabs?.selectDisbDetailIndex
  );
  const selectedLoanNumber = useSelector(
    (state: RootState) => state?.dashboardData?.selectedLoanNumber
  );
  const dashboardDataSet: DashboardData[] = useSelector(
    (state: RootState) => state?.dashboardData?.sanctionedDisbursedData
  );
  const matchedObject: DashboardData | undefined = dashboardDataSet.find(
    (data) => data?.lanNumber === selectedLoanNumber
  );
  const productName = useSelector((state: RootState) => state.tabs.productName);
  const userPermission = useSelector(userPermissionSelector);
  const userBusinessSelected = useSelector(userBusinessSelector);
  const userLoanCategory = useSelector(userLoanCatSelector);
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [tabs, setTabs] = useState<DynamicTab[]>([]);
  const [active, setActive] = useState("");

  const disbForm: any = useSelector(
    (state: RootState) => state.disbursementButtonSlice.disbursementButtonSlice
  );

  const { userProfile, businessType } = useSelector(authSelector);

  let breadcrumbItems = [
    { label: "Dashboard", path: "/" },
    { label: "Loan Summary" }, // Current page, no `path` needed
  ];
  if (productName === "TermLoanDisbursement") {
    breadcrumbItems = [
      { label: "Dashboard", path: "/" },
      { label: "Disbursement" }, // Current page, no `path` needed
    ];
  }

  const businessTypeId = useSelector(
    (state: RootState) => state?.auth?.businessType?.id
  );
  const loanCategoryData: any = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );

  useEffect(() => {
    if (selectedLoanNumber != "" && selectedLoanNumber != undefined) {
      // setIsLoadingView(true);
      const payload: any = {
        lan: encrypt(selectedLoanNumber.toString()),
        business: encrypt(businessTypeId),
        loanCategory: encrypt(loanCategoryData?.TermLoan[0]?.loanCategoryId),
      };
      postsServices
        .addPost("api/v1/dashboard/term-loan-view", payload)
        .then((response) => {
          // setIsLoadingView(false);
          dispatch(setDashboardData(response?.data?.data));
          dispatch(setMoratStatus(response?.data?.data));
        })
        .catch((error: any) => {
          const errorMessage = error.response?.data?.message;
          dispatch(
            setStatusPopup({
              status: "error",
              // message: `Disbursement requests are not permitted for this loan.`,
              message: errorMessage,
            })
          );
        });
    }
  }, [selectedLoanNumber]);

  useEffect(() => {
    if (error) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: error,
          anotherDeviceAuth: true,
        })
      );
    }
  }, [error, dispatch]);

  useEffect(() => {
    dispatch(setSelectedIndex(selectedIndex));
  }, [dispatch, selectedIndex]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const rawTabType = (params.get("tabType") || "").trim().toLowerCase();
    const normalizedTabType = rawTabType === "withdraw" ? "withraw" : rawTabType;

    if (productName !== "FlexiTermLoan") return;

    const indexByTabType: Record<string, number> = {
      accountsummary: 0,
      summary: 0,
      withraw: 1,
      payment: 2,
      statements: 3,
      statement: 3,
    };

    if (normalizedTabType && indexByTabType[normalizedTabType] !== undefined) {
      dispatch(setSelectedIndex(indexByTabType[normalizedTabType]));
      return;
    }

    const tabTypeByIndex: Record<number, string> = {
      0: "accountsummary",
      1: "withraw",
      2: "payment",
      3: "statements",
    };
    const fallbackTabType = tabTypeByIndex[selectedIndex] || "accountsummary";
    params.set("tabType", fallbackTabType);
    navigate(`/dashboard?${params.toString()}`, { replace: true });
  }, [location.search, productName, dispatch, selectedIndex, navigate]);

  useEffect(() => {
    let tabsConfig: DynamicTab[] = [];
    // Determine tabs configuration based on productName
    let selectedLoanCategoryObj: any = null;
    switch (productName) {
      case "TermLoanDisbursement":
        tabsConfig = tabsComponentRequestForDisbursementTranchRequest;
        if (userLoanCategory?.TermLoan?.length > 0) {
          selectedLoanCategoryObj = userLoanCategory?.TermLoan?.find(
            (loan: any) => loan?.businessId === userBusinessSelected?.id
          );
        }
        break;
      case "TermLoan":
        tabsConfig = tabsComponentTermLoan;
        if (userLoanCategory?.TermLoan?.length > 0) {
          selectedLoanCategoryObj = userLoanCategory?.TermLoan?.find(
            (loan: any) => loan?.businessId === userBusinessSelected?.id
          );
        }
        break;
      case "FlexiTermLoan":
        tabsConfig = tabsComponentFlexiTermLoan;
        if (userLoanCategory?.Flexi?.length > 0) {
          selectedLoanCategoryObj = userLoanCategory?.Flexi?.find(
            (loan: any) => loan?.businessId === userBusinessSelected?.id
          );
        }
        break;
      case "RequestForDisbursement":
        tabsConfig = tabsComponentRequestForDisbursement;
        break;
      default:
        tabsConfig = []; // Default or empty tabs if needed
    }
    // Remove Disbursement tab if isExistDisbursementAllowdLoan is false
    if (matchedObject?.isExistDisbursementAllowdLoan === false) {
      tabsConfig = tabsConfig.filter((tab) => tab.label !== "Disbursement");
      dispatch(setSelectedIndex(0));
    }
    // Apply role-based permissions
    if (selectedLoanCategoryObj !== null) {
      // Term loan section permissions handling
      if (selectedLoanCategoryObj?.permissionBypass === false) {
        let updatedTabs: DynamicTab[] = [];
        if (Object.keys(userPermission)?.length) {
          updatedTabs = tabsConfig.map((tab: DynamicTab) => {
            if (
              tab.label === "Account Summary" &&
              !userPermission?.rolePermissions?.includes("summary_view")
            ) {
              return {
                ...tab,
                content: <PermissionView sectionName={tab.label} />,
              };
            } else if (
              tab.label === "Withdrawal Funds" &&
              !userPermission?.rolePermissions?.includes("withdraw_view")
            ) {
              return {
                ...tab,
                content: <PermissionView sectionName={tab.label} />,
              };
            } else if (
              tab.label === "Make Payment" &&
              !userPermission?.rolePermissions?.includes("payment_view")
            ) {
              return {
                ...tab,
                content: <PermissionView sectionName={tab.label} />,
              };
            } else if (
              tab.label === "Documents" &&
              !userPermission?.rolePermissions?.includes("statement_view")
            ) {
              return {
                ...tab,
                content: <PermissionView sectionName={tab.label} />,
              };
            } else if (
              tab.label === "Mandate" &&
              !userPermission?.rolePermissions?.includes("mandate_view")
            ) {
              return {
                ...tab,
                content: <PermissionView sectionName={tab.label} />,
              };
            } else if (
              tab.label === "Service Request" &&
              !userPermission?.rolePermissions?.includes("service_request_view")
            ) {
              return {
                ...tab,
                content: <PermissionView sectionName={tab.label} />,
              };
            }
            return tab;
          });
        } else {
          updatedTabs = tabsConfig.map((tab: DynamicTab) => {
            return {
              ...tab,
              content: <PermissionView sectionName={tab.label} />,
            };
          });
        }
        setTabs(updatedTabs);
      } else {
        setTabs(tabsConfig);
      }
    }
  }, [
    productName,
    matchedObject?.isExistDisbursementAllowdLoan,
    selectedLoanNumber,
  ]);

  const selectedFormType = useSelector(
    (state: RootState) => state?.documentFormSlice
  );
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    event.preventDefault();
    if (
      selectedFormType?.formType === "continue" &&
      selectedFormType?.isNewData
    ) {
      dispatch(setDocumentDiscardModal());
      return true;
    } else {
      dispatch(setSelectedIndex(newValue));
      dispatch(resetDisbursementButtonValue());

      if (productName === "FlexiTermLoan" && location.pathname === "/dashboard") {
        const params = new URLSearchParams(location.search);
        const tabTypeByIndex: Record<number, string> = {
          0: "accountsummary",
          1: "withraw",
          2: "payment",
          3: "statements",
        };

        const tabType = tabTypeByIndex[newValue];
        if (tabType) {
          params.set("tabType", tabType);
          navigate(`/dashboard?${params.toString()}`, { replace: true });
        }
      }
    }
  };
  const handleArrowClick = () => {
    // Custom behavior here
  };
  return (
    <Box>
      {/* <MainHeading title="Disbursed Loans" backButtonVisible={true} />
      <BlueBox
        labelText="Loan account number"
        buttonText="Active"
        isActive={active}
      />  */}

      {isXsOrSm ? (
        <>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "14px",
              letterSpacing: "1px",
              color: "#168794",
              paddingTop: "15px",
            }}
          >
            {productName === "TermLoanDisbursement" &&
              selectedIndex == 0 &&
              disbForm != "createNewRequestBtn" &&
              "Disbursement"}
            {productName === "TermLoan" &&
              selectedIndex == 0 &&
              disbForm != "createNewRequestBtn" &&
              "Loan Details"}
            {/* "Loan Details" */}
          </Typography>
        </>
      ) : (
        <Breadcrumbs items={breadcrumbItems} />
      )}

      <Box>
        <CustomTabs
          content={tabs}
          onChange={handleChange}
          value={selectedIndex}
        />
      </Box>

      {/* <Tabs
        value={selectedIndex}
        onChange={handleChange}
        aria-label="tabs"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        style={{ marginTop: 16 }}
        TabIndicatorProps={{
          style: {
            backgroundColor: "#00B3B5",
          },
        }}
      >
        {tabs?.map((tab, index) => (
          <Tab
            key={index}
            label={tab?.label}
            {...a11yProps(index)}
            style={{
              textTransform: "capitalize",
              fontWeight: selectedIndex === index ? "700" : "500",
              fontSize: "16px",
              color: selectedIndex === index ? "" : "#666666",
              lineHeight: "20.32px",
              marginRight: 10,
              padding: 0,
            }}
          />
        ))}
      </Tabs> */}

      {tabs?.map((tab, index) => (
        <CustomTabPanel key={index} value={selectedIndex} index={index}>
          {tab?.content}
        </CustomTabPanel>
      ))}
    </Box>
  );
};

function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

export default FlexiTermLoan;
